import { Header } from "@/components/layout/header";
import { Footer } from "@/components/layout/footer";
import NotFound from "@/pages/not-found";
import { useBlogSeo } from "@/hooks/use-blog-seo";
import { BlogArticleContent } from "@/components/blog-content";
import { findBlogPost, BLOG_PATH } from "@/data/blog";
import "@/components/home/home.css";

export default function BlogPostPage({ slug }: { slug: string }) {
  const post = findBlogPost(slug);
  useBlogSeo(post
    ? { title: post.seoTitle, description: post.metaDescription, path: post.path, image: post.image, post }
    : { title: "Article not found | Vertex Climate", description: "This article could not be found.", path: `${BLOG_PATH}/${slug}`, image: "sauna-detail-1.webp", noindex: true });
  if (!post) return <NotFound />;
  return (
    <div className="vx-home flex flex-col min-h-[100dvh] bg-background overflow-x-clip">
      <Header />
      <main className="flex-1">
        <BlogArticleContent post={post} base={import.meta.env.BASE_URL} />
      </main>
      <Footer />
    </div>
  );
}
